import App from '@/models/App'

export default class ChatMessageUnread extends App {
    static get entity() {
        return 'ChatMessageUnreads'
    }
    static fields() {
        return {
            chatRoomId: this.attr(''),
            chatMessageId: this.attr(''),
            userId: this.attr(''),
            createdAt: this.attr(''),
        }
    }
    static apiConfig = {
        actions: {
            destroy(chatRoomId, chatMessageId) {
                return this.delete(
                    `${chatRoomId}/chats/messages/${chatMessageId}/unreads`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: 'data',
                        baseURL: App.overallURL(),
                    }
                )
            },
            destroyAll(chatRoomId) {
                return this.delete(`${chatRoomId}/chats/messages/unreads/all`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    delete: 'data',
                    baseURL: App.overallURL(),
                })
            },
        },
    }
}
